import { render, staticRenderFns } from "./IconWindows.vue?vue&type=template&id=6398c257&"
import script from "./IconWindows.vue?vue&type=script&lang=js&"
export * from "./IconWindows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports